import { render, staticRenderFns } from "./DietaryLabels.vue?vue&type=template&id=d65628ac&scoped=true&"
import script from "./DietaryLabels.vue?vue&type=script&lang=js&"
export * from "./DietaryLabels.vue?vue&type=script&lang=js&"
import style0 from "./DietaryLabels.vue?vue&type=style&index=0&id=d65628ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65628ac",
  null
  
)

export default component.exports